import React, { useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import {
  fetchAttachmentsBase64,
  resetStateAttachments,
} from "../../app/slices/attachmentsSlice";
import LoadingContainer from "../loadingContainer/loadingContainer";
import ErrorContainer from "../emptyDataContainer/emptyDataContainer";
import { useSelector, useDispatch } from "react-redux";
import PDFObject from "pdfobject";

import "./AttachmentsContainer.css";

const ViewAttachmentDialog = ({ open, handleClose, attachment }) => {
  const { list, status, error } = useSelector(
    ({ attachments }) => attachments.getBase64
  );
  const dispatch = useDispatch();

  useEffect(() => {
    resetStateAttachments(["getBase64"]);
    loadResources();
    return () => {
      resetStateAttachments(["getBase64"]);
    };
  }, []);

  useEffect(() => {
    if (list?.length) {
      PDFObject.embed(list[0]?.DATA, "#pdf-container", {
        // height: "100%",
        // width: "100%",
      });
    }
  }, [list]);

  //methods
  const loadResources = () => {
    dispatch(
      fetchAttachmentsBase64({ ATTACHMENT_ID: attachment?.ATTACHMENT_ID })
    );
  };

  //builders

  const BuildView = () => {
    if (
      list[0]?.DATA.includes("data:image/png") ||
      list[0]?.DATA.includes("data:image/jpg") ||
      list[0]?.DATA.includes("data:image/jpeg")
    ) {
      return (
        <>
          <div className="attachment-view-container">
            <img src={list[0]?.DATA} alt="img" />
          </div>
        </>
      );
    } else if (list[0]?.DATA.includes("data:application/pdf")) {
      return (
        <div className="attachment-view-container" id="pdf-container"></div>
      );
    } else {
      return (
        <div
          className="p-20 flex-row justify-content-center align-items-center"
          style={{ height: "350px" }}
        >
          Oops, Attachment format not supported!
        </div>
      );
    }
  };

  return (
    <Dialog open={open} maxWidth={"lg"} fullWidth>
      <DialogContent>
        <DialogContentText style={{ height: "calc(100vh - 180px)" }}>
          <>
            {status === "idle" && list?.length > 0 && <>{BuildView()}</>}
            {status === "loading" && (
              <LoadingContainer
                message="Working on it..."
                hasBackground={false}
              />
            )}

            {error !== null && status !== "loading" && (
              <ErrorContainer
                message={error?.message}
                hasBackground={false}
                onReload={() => {
                  loadResources();
                }}
              />
            )}
          </>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          id="btn-close"
          margin="dense"
          color="secondary"
          variant="contained"
          onClick={handleClose}
          style={{ marginLeft: "10px" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAttachmentDialog;
